@if (isPreprod) {
  <div style="display: none;">
    <div class="preprod-ribbon">Preprod</div>
  </div>
}

<!-- -->
<div class="notification-container" appNotificationQueue></div>
<!-- -->
<router-outlet class="flex"></router-outlet>
<!-- -->
@if (!isOnSpecificPage()) {
  <div class="ErrorBox">
    <button class="report-button" (click)="toggleForm()">
      <i class="fas fa-exclamation-circle"></i>
    </button>
    <div class="report-form" [class.show]="isFormVisible">
      <div class="form-header">
        <div>
          <h3>Contacter le support</h3>
        </div>
        <div>
          <button class="close-button" (click)="toggleForm()">
            <i class="fas fa-times"></i>
          </button>
        </div>
      </div>
      <select [(ngModel)]="incidentType">
        <option value="1">Anomalie</option>
        <option value="2">Amélioration</option>
        <option value="3">Question</option>
      </select>
      <textarea placeholder="Indiquez le motif de votre demande" [(ngModel)]="incidentDescription"></textarea>
      <button (click)="submitIncident()" class="submit">Envoyer</button>
    </div>
  </div>
}